type Props = {
  pageTitle: string
  description: string
  /** Keep this page out of search engines (e.g. the hidden April Fools page). */
  noindex?: boolean
}

export const Metadata = ({ pageTitle, description, noindex }: Props) => {
  const newTitle = `UQRDM - ${pageTitle}`
  return (
    <>
      <title>{newTitle}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
    </>
  )
}
